import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type ThreadListInfoProps = {
  cleanupOldPostsEnabled: boolean;
  dayCount: number;
};

export function ThreadListInfo({ cleanupOldPostsEnabled, dayCount }: ThreadListInfoProps) {
  const { t } = useSonTranslation('ThreadlistBlock');

  if (!cleanupOldPostsEnabled) {
    return (
      <div className="thread-list__info">
        <p>{t('default.cleanupOldPostsDisabled')}</p>
      </div>
    );
  }

  if (cleanupOldPostsEnabled && dayCount) {
    return (
      <div className="thread-list__info">
        <p>
          {dayCount === 1
            ? t('default.cleanupOldPostsEnabledSingular', { count: dayCount })
            : t('default.cleanupOldPostsEnabledPlural', { count: dayCount })}
        </p>
      </div>
    );
  }
}
